<template>
    <div class="alm-bdg-wrapper" :class="{ 'alm-bdg-border': showBorder }">
        <span class="alm-bdg" :class="badgeClass">
            <img v-if="value === STATUS.DRAFT" src="../../../../public/icons/landscape/CombinedShape.svg" alt="" />
            <img v-else-if="value === STATUS.DEPLOYING" src="../../../../public/icons/landscape/path.svg" alt="" />
            <img v-else-if="value === STATUS.READY" src="../../../../public/icons/landscape/Group.svg" alt="" />
            <img
                v-else-if="value === STATUS.FAILED"
                src="../../../../public/icons/landscape/validation-alert.svg"
                alt=""
            />
            <img
                v-else-if="value === STATUS.INCOMPLETE"
                src="../../../../public/icons/landscape/validation-empty.svg"
                alt=""
            />
            <img
                v-else-if="value === STATUS.QUEUED"
                src="../../../../public/icons/landscape/due-soon.svg"
                alt=""
            />
           <span class="alm-bdg-title">{{ itemTitle.toUpperCase() }}</span>
        </span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";
import { STATUS } from "@/components/pages/landscape/LandscapeManagementInterfaces";

export default defineComponent({
    data() {
        return {
            STATUS,
            localizer: new Localizer(this.$store),
            badgeClass: "",
        };
    },
    props: {
        params: Object,
    },
    computed: {
        value() {
            return this.params?.value;
        },
        showBorder() {
            return this.params?.showBorder ?? false;
        },
        itemTitle(): string {
            let title: string = "";
            switch (this.value) {
                case STATUS.DRAFT:
                    title = this.localizer.Localize("LandscapeManagementManage_StatusDraft");
                    this.badgeClass = "alm-bdg-draft";
                    break;
                case STATUS.DEPLOYING:
                    title = this.localizer.Localize("LandscapeManagementManage_StatusDeploying");
                    this.badgeClass = "alm-bdg-deploying";
                    break;
                case STATUS.READY:
                    title = this.localizer.Localize("LandscapeManagementManage_StatusReady");
                    this.badgeClass = "alm-bdg-to-deploy";
                    break;
                case STATUS.FAILED:
                    title = this.localizer.Localize("LandscapeManagementManage_StatusFailed");
                    this.badgeClass = "alm-bdg-failed";
                    break;
                case STATUS.INCOMPLETE:
                    title = this.localizer.Localize("LandscapeManagementManage_StatusIncomplete");
                    this.badgeClass = "alm-bdg-incomplete";
                    break;
                case STATUS.QUEUED:
                    title = this.localizer.Localize("LandscapeManagementManage_StatusQueued");
                    this.badgeClass = "alm-bdg-queued";
                    break;
                default:
                    title = "";
            }
            return title;
        },
    },
});
</script>

<style>
.alm-bdg-wrapper {
    display: inline;
    padding-right: 16px;
}

.alm-bdg-border {
    border-right: 1px solid #e6ebf8;
}

.alm-bdg-draft {
    background-color: var(--accent-color-blue-25);
    color: var(--accent-color-blue);
}

.alm-bdg-deploying {
    background-color: var(--accent-color-yellow-25);
}

.alm-bdg-to-deploy {
    background-color: var(--accent-color-green-25);
    color: var(--accent-color-green);
}

.alm-bdg-failed {
    background-color: var(--accent-color-red-25);
    color: var(--accent-color-red);
}

.alm-bdg-incomplete {
    background-color: var(--accent-color-violet-25);
    color: var(--accent-color-violet-75);
}

.alm-bdg-queued {
    background-color: var(--accent-color-concord-05);
    color: var(--accent-color-concord);
}

.alm-bdg > img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
}

.alm-bdg {
    display: inline-flex;
    align-items: center;
    padding: 4px 6px;
    border-radius: 4px;
    vertical-align: middle;
}

.alm-bdg-title {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
}
</style>
